import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { getQueryParam } from '@zola-helpers/client';
import { Link, InfoFilledIcon } from '@zola/zola-ui';
import _get from 'lodash/get';

import zoomConfig from '../../../../util/zoomConfig';

import css from './zoomConnect.module.less';

const env = _get(window, 'zola.env', '');
const envObj = _get(zoomConfig, [env], {});

const AUTH_URL = `https://zoom.us/oauth/authorize?response_type=code&client_id=${envObj.clientId}&redirect_uri=${envObj.baseUrl}/wedding/manage/virtual/connect`;

const ZoomConnect = ({ onGetAccessToken }) => {
  useEffect(() => {
    const code = getQueryParam('code');

    if (code) {
      onGetAccessToken(code).then(() => browserHistory.push('/wedding/manage/virtual/create/new'));
    }
  }, []);

  return (
    <div className={css.container}>
      <h1 className={css.title}>Connect Your Zoom Account</h1>
      <p className={css.subTitle}>
        Sign in (or sign up for free!) below to add a virtual event to your site.
      </p>
      <a href={AUTH_URL}>
        <img
          src="https://marketplacecontent.zoom.us/zoom_marketplace/img/add_to_zoom.png"
          height="32"
          alt="Add to ZOOM"
          className={css.img}
        />
      </a>
      <div className={css.noticeContainer}>
        <h2 className={css.noticeTitle}>
          <InfoFilledIcon className={css.noticeIcon} />
          Make Sure to Use Your Personal Account
        </h2>
        <p className={css.noticeBody}>
          Company Zoom accounts may not let you host personal events.
        </p>
      </div>
      <p className={css.terms}>
        By using Zola&apos;s Virtual Events platform and connecting your Zoom account, you agree to
        these{' '}
        <Link
          href="https://welcome.zola.com/virtualevents-terms-of-use/"
          rel="noopener noreferrer"
          target="_blank"
          arrow
          className={css.link}
        >
          Terms of Use
        </Link>
      </p>
    </div>
  );
};

ZoomConnect.propTypes = {
  onGetAccessToken: PropTypes.func.isRequired,
};

export default ZoomConnect;



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomConnect/ZoomConnect.jsx